<script lang="ts">
  import { Callout } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { CalloutModuleProps } from './types';

  const {
    entryId,
    customCssClass,
    colorMode,
    heading,
    headingLevel,
    headingSize,
    body,
    bodySize,
    ctaItems: ctaItemsFromProps,
  }: CalloutModuleProps = $props();
</script>

<Callout
  class="CalloutModule {customCssClass}"
  data-entry-id={entryId}
  {colorMode}
  headingText={heading}
  {headingLevel}
  {headingSize}
  {bodySize}
>
  <!-- This usage of DynamicChildrenComponent uses RichTextBlockComponent, but we still need the RichTextFieldComponent
   class because of styling nested to that class. We do not want to use RichTextFieldComponent in Contentful because
   that gives the user more formatting options than we want to allow -->
  {#snippet bodyText()}
    {#if body}
      <div class="RichTextFieldComponent">
        <DynamicChildrenComponent children={body} />
      </div>
    {/if}
  {/snippet}
  {#snippet ctaItems()}
    {#if ctaItemsFromProps}
      <DynamicChildrenComponent
        children={ctaItemsFromProps}
        passThroughProps={{
          variant: 'text',
          size: 'regular',
        }}
      />
    {/if}
  {/snippet}
</Callout>
